import React, { memo } from "react";
import EyeIcon from "assets/eye_new.svg";

const ToggleVisibility = ({
  visible = false,
  onClick,
  className,
  bgColorShowing,
  style,
}) => {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      onClick={onClick}
      className={`flex items-center justify-center rounded-full ${
        visible ? bgColorShowing || "bg-transparent" : "bg-transparent"
      } cursor-pointer ${className}`}
      style={style}
    >
      <img src={EyeIcon} alt="" className=""/>
    </div>
  );
};

export default memo(ToggleVisibility);
